// extracted by mini-css-extract-plugin
export default {"layout":"j6l2qFP7","header":"CngzayLc","logo":"YWwH2_ZM","menu":"LPlXI2pQ","actions":"ucuTrRrn","icon":"hDd1Uron","avatar":"IZPuqXaX","content":"GQmjz5_9","footer":"knJkQKQv"};